// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrap":"_c37ddf5","unregister":"_528c16e"};